module.exports = __webpack_public_path__ + "img/BRN.fb7ae35b.svg";